/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/17
 * @updateTime 2021/8/17
 * @decription 公共该组件-按钮列表组件入口js
 */
export default {
    name: 'ccButtonList',
    // 混入
    mixins: [],
    // 依赖组件
    components: {},
    // 参数
    props: {
        // 按钮数据
        data: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    // 数据
    data() {
        return {
            // 当前作用域变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-cc-button-list'
            },
            // 按钮列表
            buttonList: [],
            // 气泡弹出框数据
            actions: [],
            // 是否显示气泡弹出框
            showPopover: false
        };
    },
    // 计算属性
    computed: {
        /**
         * 容器类名
         * @returns {Array<String>} 类名数组
         * */
        wrapClasses() {
            return [
                this.scope.prefixCls
            ];
        }
    },
    // 监听
    watch: {
        // 监听数据变化
        data: {
            // 立即执行
            immediate: true,
            // 发生变化，更新按钮数据
            handler() {
                // 重新组装数据
                this.assembleData();
            }
        }
    },
    // 创建完成
    created() {
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {

        /**
         * 组装数据
         * @returns {void}
         * */
        assembleData() {
            // 如果数据不存在，则直接置空数据并返回
            if (!this.data || !this.data.length) {
                this.buttonList = [];
                this.actions = [];
                return;
            }
            if (this.data.length <= 4) {
                this.buttonList = this.data;
                this.actions = [];
                return;
            }
            // 按钮列表是取前4个
            this.buttonList = this.data.slice(0, 4);
            // 气泡弹出框数据取后面的数据
            this.actions = this.data.slice(4);
        },

        /**
         * 点击按钮
         * @param {Object} btnItem 按钮信息项
         * @returns {void}
         * */
        eClickBtn(btnItem) {
            // 通知父级组件，点击了对应的按钮
            this.$emit('click-item', btnItem);
        },

        /**
         * 气泡弹出框中选项的点击事件
         * @param {Object} action 动作对象
         * @returns {void}
         * */
        eSelect(action) {
            // 触发对应的信息项的点击事件
            this.eClickBtn(action);
        }
    }
};
